import { render, staticRenderFns } from "./DesignTender.vue?vue&type=template&id=9d33c340&"
import script from "./DesignTender.vue?vue&type=script&lang=js&"
export * from "./DesignTender.vue?vue&type=script&lang=js&"
import style0 from "./DesignTender.vue?vue&type=style&index=0&id=9d33c340&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports